import {Component, inject} from '@angular/core';
import {Shared} from '../services/shared';
import {Checkout} from '../checkout/checkout';
import {Router, RouterLink} from '@angular/router';
import {CartService} from '../services/cart';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-plans',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './plans.html',
  styleUrl: './plans.scss'
})
export class Plans {

  sharedService = inject(Shared)
  cartService = inject(CartService)

  openModal() {

    // console.log('clicked')
    const btn = document.querySelector('[data-bs-toggle="modal"][data-bs-target="#exampleModal"]') as HTMLElement;
    if (btn) btn.click();
    else console.warn('Button not found');
    this.sharedService.requestSignUp()
  }

  protected readonly Checkout = Checkout;

  addGrowthPlan() {
    this.cartService.addItem({
      type: 'growth_subscription',
      id: 'growth_plan',
      quantity: 1
    });
  }

  addUltimatePlan() {
    this.cartService.addItem({
      type: 'ultimate_subscription',
      id: 'ultimate_plan',
      quantity: 1
    });
  }

  addCredits(amountCredits: number) {
    if (amountCredits === 100) {
      this.cartService.addItem({
        type: 'credits_100',
        id: `credits_100`,
        quantity: 1
      });
    }
    if (amountCredits === 250) {
      this.cartService.addItem({
        type: 'credits_250',
        id: `credits_250`,
        quantity: 1
      });
    }
    if (amountCredits === 750) {
      this.cartService.addItem({
        type: `credits_750`,
        id: `credits_750`,
        quantity: 1
      });
    }

  }

  viewCart() {
    console.log(this.cartService.getItems());
  }
}
